import {Component, inject, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Router, RouterLink, RouterLinkActive, RouterOutlet} from "@angular/router";
import {IconComponent} from "../../../shared-module/components/icon/icon.component";
import ModalService from "../../../shared-module/services/modal.service";
import {LogoutModalComponent} from "../../components/logout-modal/logout-modal.component";
import {AuthService} from "../../../shared-module/services/auth.service";
import {ModalEventType} from "../../../shared-module/types/modal.type";
import {AsyncPipe, Location, NgOptimizedImage} from "@angular/common";
import RelationContact from "../../../shared-module/model/relation-contact.model";
import AddressPipe from "../../../shared-module/pipes/address.pipe";
import {Subscription} from "rxjs";
import {Content, HeaderService} from "../../../shared-module/services/header.service";
import {ButtonComponent} from "../../../shared-module/components/button/button.component";
import {Scope} from "../../../shared-module/enums/scope";
import {ApplicationConfig, config} from "../../../../config";

@Component({
    selector: 'app-dashboard-layout',
    imports: [
    RouterOutlet,
    RouterLink,
    IconComponent,
    RouterLinkActive,
    AsyncPipe,
    AddressPipe,
    NgOptimizedImage,
    ButtonComponent
],
    templateUrl: './dashboard-layout.component.html',
    changeDetection: ChangeDetectionStrategy.Eager,
    styleUrl: './dashboard-layout.component.scss'
})
export class DashboardLayoutComponent implements OnInit {

  private readonly router: Router = inject(Router);
  private readonly modalService: ModalService = inject(ModalService);
  protected readonly authService: AuthService = inject(AuthService);
  protected readonly config: ApplicationConfig = config;
  readonly headerService: HeaderService = inject(HeaderService);
  readonly location: Location = inject(Location);


  public blurred: boolean = false;
  public multiple: boolean = false;
  public menuOpened: boolean = false;

  public title: string = '';
  public subtitle: string = '';

  public user: RelationContact | null = null;
  public showBackButton: boolean = false;
  private modalSubscription: Subscription | null = null;

  public ngOnInit(): void {
    this.authService.getUser().subscribe((user: RelationContact | null) => {
      if (!user) {
        return;
      }
      this.user = user;
      this.blurred = user.scope.type !== Scope.ALL;
      this.multiple = (user && user.relations.length > 1) ?? false;
    });

    this.headerService.content().subscribe((content: Content) => {
      this.title = content.title.replace('${appName}', config.appName);
      this.subtitle = content.subtitle.replace('${appName}', config.appName).replace('${companyName}', config.companyName);
      this.showBackButton = content.showBackButton;
    });
  }

  public authMenuHandle(): void {
    if (this.modalSubscription) {
      return;
    }
    this.modalSubscription = this.modalService.open(
      LogoutModalComponent,
      null,
      {
        title: 'Uitloggen',
        dismissOnBackdropClick: true,
        showCloseButton: true,
        showBackdrop: true,
        width: '550px',
      }
    ).subscribe((event: ModalEventType) => {
      if (!['closed', 'dismissed', 'confirmed', 'canceled'].includes(event.type)) {
        return;
      }

      this.modalSubscription?.unsubscribe();
      this.modalSubscription = null;

      if (event.type === 'confirmed') {
        this.logOut();
      }
    });
  }

  public logOut(redirectUrl: string | null = null): void {
    this.authService.logout(redirectUrl).subscribe();
  }

  protected logInToChangeScope(): void {
    const urlTree = this.router.parseUrl(this.router.url);
    urlTree.queryParams = {};
    urlTree.fragment = null; // optional;

    this.logOut(urlTree.toString());
  }


  public isSingleScope(): boolean
  {
    return this.user?.scope.type !== Scope.ALL;
  }

  public closeMenu(){
    this.menuOpened = false;
  }

  public toggleMenu(){
    this.menuOpened = !this.menuOpened;
  }
}
